import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import Common from "./Common";
import Auth from "./Auth";
import Accounts from "./Accounts";
import Notification from "./Notification";
import Scripts from "./Scripts";
import ActionsFacebook from "./ActionsFacebook";
import ChangeElementScript from "./ChangeElementScript";
import InfoAccountPopup from "./InfoAccountPopup";
import PostsFacebook from "./PostsFacebook";
import Groups from "./Groups";
import Pages from "./Pages";
import Category from "./Category";
import Questions from "./Questions";
import Location from "./Location";
import Users from "./Users";
import Settings from "./Settings";
import UserProxy from "./UserProxy";

export default history =>
  combineReducers({
    router: connectRouter(history),
    common: Common,
    auth: Auth,
    manageAccountFacebook: Accounts,
    notification: Notification,
    scripts: Scripts,
    actions: ActionsFacebook,
    elementInScript: ChangeElementScript,
    infoAccountPopup: InfoAccountPopup,
    postsFacebook: PostsFacebook,
    Groups: Groups,
    Pages: Pages,
    Category: Category,
    Questions: Questions,
    Location: Location,
    users: Users,
    settings: Settings,
    UserProxies: UserProxy
  });
